import React, {useLayoutEffect} from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const RpFiltersScrollContainer = React.forwardRef((props, ref) => {
    const { setScrollContainerReady, slidePaneOpen, setSlidePaneOpen, boxRefs, children } = props;

    useLayoutEffect(() => {
        setScrollContainerReady(true);

        return () => {
            setScrollContainerReady(false);
        };
    }, [setScrollContainerReady]);

    return (
        <Box
            ref={ref}
            sx={{
                flex: 1,
                p: 2,
                height: 'calc(100vh - 225px)',
                overflowY: slidePaneOpen ? 'hidden' : 'auto',
                overflowX: 'hidden',
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'primary.main',
                },
                scrollbarColor: 'primary.main #f0f0f0',
                position: 'relative',
                right: slidePaneOpen ? '110%' : 0,
                transition: 'right 0.5s ease',
                scrollBehavior: 'smooth',
            }}
        >
            {React.Children.toArray(children).map((child, idx) =>
                (<div ref={el => boxRefs.current[idx] = el} data-idx={idx} key={idx}>
                    {React.cloneElement(child, {
                        ...child.props,
                        handleSlidingPanel: setSlidePaneOpen,
                    })}
                </div>)
            )}
        </Box>
    );
});

RpFiltersScrollContainer.displayName = 'RpFiltersScrollContainer';

RpFiltersScrollContainer.propTypes = {
    setScrollContainerReady: PropTypes.func.isRequired,
    slidePaneOpen: PropTypes.bool.isRequired,
    setSlidePaneOpen: PropTypes.func.isRequired,
    boxRefs: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

export default RpFiltersScrollContainer;